export const CONTINUE_SHOPPING_LINK = '/:language/catalog/';

export const CHECKOUT_LINK = '/:language/shop/checkout/';
